<template>
    <div class="over">
        <div class="evaluation">
            建筑能耗评价
        </div>
        <div class="evaluat">
            <div class="top">
                <div :class="'score ' + statusColor">
                    {{status}}
                    <div class="standard">
                        <img src="../../../assets/img/iconEnerover.png" alt="">
                    </div>
                    <div class="tip">
                        根据《民用建筑能耗标准》规定实时评价值小于引导值，建筑能耗水平优秀，请继续保持！
                    </div>
                </div>
                
                <div class="analyse" @click="$router.push('/Home/WorkBench/Comparison')">能耗分析<i class="el-icon-arrow-right"></i></div>
            </div>
            <div class="bottom">
                <div class="box">
                    <div class="box-item">
                        <!-- <div class="val">70</div> -->
                        <div class="keyName">引导值 <b style="font-size:20rem">70</b></div>
                    </div>
                    <div class="box-item" :style="translation">
                        <div class="val">{{constantValue}}</div>
                        <div class="keyName">实时评价值</div>
                    </div>
                    <div class="box-item">
                        <!-- <div class="val">85</div> -->
                        <div class="keyName">约束值 <b style="font-size:20rem">85</b></div>
                    </div>
                </div>
                <div class="progrees"></div>
            </div>
        </div>
        <div class="evaluation">
            建筑能耗占比
        </div>
        <div class="accounted">
            <div class="tabDate">
                <span :class="dateIdx == 0?'se':''" @click="tabIdx(0)">日</span>
                <span :class="dateIdx == 1?'se':''" @click="tabIdx(1)">周</span>
                <span :class="dateIdx == 2?'se':''" @click="tabIdx(2)">月</span>
                <span :class="dateIdx == 3?'se':''" @click="tabIdx(3)">年</span>
            </div>
            <div class="tabType">
                <div class="lei">
                    分类能耗占比
                </div>
                <div class="lei">
                    分项能耗占比
                </div>
            </div>
            <div class="chart">
                <div class="chartItem">
                    <Charts id="chartOne" :option="optionOne" v-if="Object.keys(typesArr1).length > 0"/>
                    <Loading LoadingId="energyLoading" :scale="1" v-if="Object.keys(typesArr1).length == 0 && isRequest == true"/>
                    <img src="../../../assets/img/not_found_data.png" alt="" v-if="isRequest == false && Object.keys(typesArr1).length == 0">
                </div>
                <div class="chartItem">
                    <Charts id="chartTwo" :option="optionTwo" v-if="Object.keys(typesArr2).length > 0"/>
                    <Loading LoadingId="typEnergyLoad" :scale="1" v-if="Object.keys(typesArr2).length == 0 && isRequest1 == true"/>
                    <img src="../../../assets/img/not_found_data.png" alt="" v-if="isRequest1 == false && Object.keys(typesArr2).length == 0">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import {EleResize} from '../../../util/a.js'

import { getProjectTypeEnergy, getProjectItemEnergy, getProjectPowerTotalOut } from '../../../api/power'
import { dayStart } from './../../../util/DateUtil'
import Charts from '../../../components/common/Charts.vue'
import Loading from '../../../components/common/Loading.vue'
export default {
    data(){
        return {
            dateIdx:0,
            allType:[], // 所有的分类比数据 
            allItem:[], // 所有的分项能耗
            constantValue:0, // 定值
            typesArr1:[],
            typesArr2:[],
            isRequest:true, // 为true，则表示正在请求数据，为false则请求完成 分类是否在请求
            isRequest1:true, // 分项是否在请求
        }
    },
    components:{
        Charts, Loading
    },
    computed:{
        parkInfo(){
            return this.$store.state.project.projectInfo
        },
        translation(){
            return `left:${this.constantValue>100?100:this.constantValue}%;`
        },
        status(){
            return this.constantValue > 100?'差':this.constantValue < 80?'优秀':'良好'
        },
        statusColor(){
            return this.constantValue > 100?'great':this.constantValue < 80?'':'good'
        },
        optionOne(){
            return {
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
						return  `${params.marker}${params.name}： <b style='font-size:18px;'>${params.value}</b><b style='font-size:14px;'> %</b>`;
						
					},
                },
                color: ['#f6bd16','#6dc8ec','#e8684a', '#9270ca'],
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    show:false
                },
                series: [
                    {
                    type: 'pie',
                    radius: ['35%', '55%'],
                    data: this.typesArr1,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        }
                    },
                    itemStyle: {
                        borderWidth: 2,
                        borderColor: '#fff',
                        borderMiterLimit:0,
                        shadowBlur :0
                    },
                    label: {
                        // alignTo: 'edge', // edge  labelLine
                        formatter: '{name|{b}}\n{time|{c} %}',
                        minMargin: 5,
                        fontSize: 14,
                        edgeDistance: 10,
                        lineHeight: 15,
                        rich: {
                            time: {
                                fontSize: 14,
                                color: '#0D94FF'
                            }
                        },
                    },
                    }
                ]
            }
        },
        optionTwo(){
            return {
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
						return  `${params.marker}${params.name}： <b style='font-size:18px;'>${params.value}</b><b style='font-size:14px;'> %</b>`;
					},
                },
                // color: ['#f6bd16','#e8684a','#6dc8ec', '#9270ca'],
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    show:false
                },
                grid: {
                    top: '20%',
                    right:'5%',
                    left:'5%',
					bottom:'15%'
                },
                series: [
                    {
                    type: 'pie',
                    radius: ['35%', '55%'],
                    data: this.typesArr2,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        }
                    },
                    itemStyle: {
                        borderWidth: 2,
                        borderColor: '#fff',
                        borderMiterLimit:0,
                        shadowBlur :0
                    },
                    label: {
                        // alignTo: 'edge',
                        formatter: '{name|{b}}\n{time|{c} %}',
                        minMargin: 5,
                        edgeDistance: "5%",
                        fontSize: 14,
                        lineHeight: 15,
                        rich: {
                            time: {
                                fontSize: 14,
                                color: '#0D94FF'
                            }
                        }
                    },
                    }
                ]
            }
        }
    },
    mounted(){
        
        this.typeEnergy()
        this.getItemEnergy() 
        this.getYearEnergy()
    },
    methods:{
        tabIdx(idx){
            this.dateIdx = idx
            this.typesArr1 = this.allType[idx]
            this.typesArr2 = this.allItem[idx]
        },
        async typeEnergy(){
            let today = dayStart(new Date())
            this.isRequest = true
            try{
                let res = await Promise.all([
                    getProjectTypeEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        range:'DAY'
                    }),
                    getProjectTypeEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        range:'WEEK'
                    }),
                    getProjectTypeEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        range:'MONTH'
                    }),
                    getProjectTypeEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        range:'YEAR'
                    })
                ])
                // console.log(res);
                res.forEach(item =>{
                    if(item.data.code == 200){
                        let result = item.data.data.result
                        let sum = result.power + result.water + result.heat + result.cooling
                        let power = result.power / sum * 100
                        let water = result.water / sum * 100
                        let heat = result.heat / sum * 100
                        let cooling = result.cooling / sum * 100
                        // console.log(power, water, heat, cooling);

                        let arr = [
                            { value: power.toFixed(0), name: '电' },
                            { value: water.toFixed(0), name: '水' },
                            { value: heat.toFixed(0), name: '热' },
                            { value: cooling.toFixed(0), name: '冷' },
                        ].filter((n)=>n.value !== 0)
                        let newArr = arr.filter(item =>Number(item.value) !== 0)
                        this.allType.push(newArr)
                    }else{
                        this.allType.push([])
                    }

                    
                })
                
                this.typesArr1 = this.allType[0]
            }catch(err){
                console.log(err);
                this.isRequest = false
            }
        },
        async getItemEnergy(){
            this.isRequest1 = true
            let today = dayStart(new Date())
            try{
                let res = await Promise.all([
                    getProjectItemEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        range:'DAY'
                    }),
                    getProjectItemEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        range:'WEEK'
                    }),
                    getProjectItemEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        range:'MONTH'
                    }),
                    getProjectItemEnergy({
                        date:today,
                        powerType:'',
                        projectId:this.$store.state.project.currentProject.projectId,
                        range:'YEAR'
                    })
                ])
                

                res.forEach(item =>{
                    let result = item.data.data.result
                    // console.log(result);
                    let sum = result['空调'] + result['照明'] + result['动力'] + result['特殊']
                    let colors = [
                        {
                            key:'照明',
                            color:'#f6bd16'
                        },
                        {
                            key:'空调',
                            color:'#6dc8ec'
                        },
                        {
                            key:'动力',
                            color:'#e8684a'
                        },
                        {
                            key:'特殊',
                            color:'#9270ca'
                        },
                    ]
                    let arr = []
                    Object.keys(result).forEach(item =>{
                        if(result[item] == 0) return
                        let current = result[item] / sum * 100
                        let color = colors.find(c=>c.key == item)
                        arr.push({ 
                            value: current.toFixed(2), 
                            name: item,
                             itemStyle:{
                                color:color.color
                             }
                        })
                    })
                    
                    this.allItem.push(arr)
                })
                
                this.typesArr2 = this.allItem[0]

            }catch(err){
                console.log(err);
                this.isRequest1 = false
            }
        },
        // 获取年用电量计算项目实测值 
        async getYearEnergy(){
            let res = await getProjectPowerTotalOut({
                projectId:this.$store.getters.projectId,
                start:new Date().getFullYear() + '-01-01T00:00:00Z',
                end:new Date().getFullYear() + '-12-31T00:00:00Z',
            })
            
            if(res.data.code == 200){
                let total = res.data.data.total
                if(this.parkInfo.projectArea){
                    let constantValue = total / parseInt(this.parkInfo.projectArea) 
                    
                    this.constantValue = Number(constantValue).toFixed(2)
                }
            }else{
                // console.log(res.data.errMsg);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.over{
    .evaluation{
        height: 3.2vh;
        padding-top: 7rem;
        padding-left: 13rem;
        line-height: 28rem;
        box-sizing: border-box;
        font-size: 16rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        position: relative;
        &::before{
            content: '';
            width: 5rem;
            height: 18rem;
            background: #0D94FF;
            position: absolute;
            left: 0;
            top: 12.5rem;
        }
    }

    .evaluat{
        height: 15vh;
        background: rgba(0,43,102,0.04);
        box-sizing: border-box;
        border-top: 1px solid rgba(0,0,0,0.15);
        position: relative;
        .top{
            height: 7vh;
            border-bottom: 1px solid rgba(0,0,0,0.06);
            padding: 8rem 22rem 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .score{
                font-size: 32rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #68D86A;
                position: relative;
                .standard{
                    position: absolute;
                    left: calc(100% + 10rem);
                    white-space: nowrap;
                    bottom: 2rem;
                    font-size: 12rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #999999;
                    &>img{
                        width: 15rem;
                        height: 16rem;
                        vertical-align: middle;
                        margin-right: 4rem;
                        margin-bottom: 2rem;
                    }
                    
                }
                .tip{
                    width: 17vw;
                    height: 5vh;
                    position: absolute;
                    top: -24%;
                    left: 169%;
                    background: #fff;
                    font-size: 12rem;
                    padding: 5rem 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #666666;
                    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.08);
                    border-radius: 4px;
                    display: none;
                    &::before{
                        content: '';
                        width: 0;
                        height: 0;
                        border: 8rem solid transparent;
                        border-right: 8rem solid #fff;
                        position: absolute;
                        top: 58%;
                        left: -16rem;
                    }
                }
            }
            .score:hover {
                .tip{
                    display: block;
                }
                
            }
            .great{
                color:#FD4238
            }
            .good{
                color:#F5AA00
            }

            .analyse{
                width: 4.5vw;
                height: 2.8vh;
                line-height: 2.8vh;
                white-space: nowrap;
                text-align: center;
                background: #EAECED;
                border-radius: 4rem;
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                cursor: pointer; 
                &>i{
                    font-weight: 900;
                }
            }
            
        }

        .bottom{
            padding:0 2.5vw;
            
            .box{
                height: 4vh;
                display: flex;
                // justify-content: space-around;
                justify-content: flex-end;
                align-items: center;
                position: relative;

                .box-item{
                    text-align: center;
                    position: absolute;
                    transform: translate(-50%, 0);
                    bottom:-36px;
                    .val{
                        font-size: 24rem;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333;
                    }
                    .keyName{
                        font-size: 16rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #333333;
                    }

                    &::before{
                        content: '';
                        width: 3rem;
                        height: 10rem;
                        position: absolute;
                        left: 50%;
                        top: -11px;
                        transform: translate(-50%, 0%);
                        background: #FFFFFF;
                        box-shadow: 0px 0px 1px 0px rgba(8,1,3,0.32);
                        opacity: 0.7;
                    }
                }
                .box-item:nth-child(1){
                    left: 70%;
                }
                .box-item:nth-child(3){
                    left: 85%;
                }
                .box-item:nth-child(2){
                    left: 0;
                    background: url('../../../assets/img/realvalue.png') no-repeat;
                    background-size: 100% 100%;
                    width: 110rem;
                    height: 70rem;
                    transform: translate(-50%, 8%);
                    bottom: -2px;
                    .val{
                        color: #0D94FF;
                    }
                    &::before{
                        content: '';
                        width: 10rem;
                        height: 10rem;
                        background:linear-gradient(to bottom right, #fff 0%, #fff 49.9%, rgba(13,148,255,0.3) 50%,#0D94FF 100%);
                        position: absolute;
                        left: 50%;
                        top: 97%;
                        transform: translate(-50%, 0%);
                        rotate: 45deg;
                        display: none;
                    }
                }
            }
            .progrees{
                height: 0.8vh;
                background: linear-gradient(90deg, #68D86A 69%, #F5AA00 84%, #FD4238 100%);
                border-radius: 4px;
            }
        }
    }

    .accounted{
        height: 26.5vh;
        background: rgba(0,43,102,0.04);
        box-sizing: border-box;
        border-top: 1px solid rgba(0,0,0,0.15);

        .tabDate{
            height: 30rem;
            line-height: 30rem;
            overflow: hidden;
            &>span{
                display: inline-block;
                height: 100%;
                margin-right:15rem ;
                border-top: 2px solid transparent;
                float: right;
                cursor: pointer;
            }
            .se{
                border-top: 2px solid #409EFF;
            }
        }

        .tabType{
            height: 33rem;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            .lei{
                height: 100%;
                width: 192rem;
                text-align: center;
                line-height: 33rem;
                background-color: #fff;
                border-radius: 17rem;
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
            }
        }

        .chart{
            height: 20.5vh;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .chartItem{
                width: 50%;
                height: 100%;
                position: relative;
                #chartOne{
                    width: 100%;
                    height: 100%;
                }
                #chartTwo{
                    width: 100%;
                    height: 100%;
                }

                &>img{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 50%;
                    height: 50%;
                }
            }
        }
    }
}
</style>